import { I18nWording } from '@/services/i18n';
import { isMissingTranslation } from '@/utils/isMissingTranslation';

export const hasNameError = (name: I18nWording): boolean => {
  return isMissingTranslation(name);
};
